/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ECharts from "echarts-for-react";
import { equipmentFaultStatusColors } from "data/data";

const makeBaseOption = () => ({
  series: [
    {
      name: "",
      type: "gauge",
      startAngle: 90,
      endAngle: -270,

      center: ["50%", "50%"],
      radius: "100%",

      pointer: { show: false },

      progress: {
        show: true,
        overlap: false,
        roundCap: false,
        clip: false,
      },

      axisLine: {
        lineStyle: {
          width: 12,
          color: [[1, "#b2b2b2"]],
        },
      },

      splitLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },

      // ✅ title/detail 대신 detail 하나로 2줄 출력
      title: { show: false },

      detail: {
        show: true,
        offsetCenter: [0, "0%"], // ✅ 중앙
        formatter: () => "",     // 생성 시 덮어씀
        rich: {
          label: {
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 22,       // ✅ 줄간격(첫 줄)
          },
          value: {
            fontSize: 14,
            fontWeight: 600,
            lineHeight: 26,       // ✅ 줄간격(둘째 줄)
            padding: [2, 0, 0, 0] // ✅ 두 줄 사이 살짝 띄움
          },
        },
      },

      data: [],
    },
  ],
});

export function StatusChart({ EquipmentFaultStatusList, statusDatas }) {
  const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
  const [options, setOptions] = useState([]);
  const chartRefs = useRef([]);

  useEffect(() => {
    if (!statusDatas || statusDatas.length === 0 || !EquipmentFaultStatusList) {
      init()
      return;
    }

    const sum = statusDatas.reduce(
      (acc, cur) => acc + parseInt(cur?.count || 0, 10),
      0
    );

    const minVisiblePercent = 1;
    const next = [];

    EquipmentFaultStatusList.forEach((item) => {
      if (item.code?.startsWith("O4_C")) return;

      const opt = makeBaseOption();

      if (platformServer === 'NANTONG')
        opt.series[0].axisLine.lineStyle.width = 7

      const color =
        equipmentFaultStatusColors.find((d) => d.code === item.code)?.color ||
        "#4caf50";

      const matched = statusDatas.find((s) => s.groups.includes(item.code));
      const count = matched ? parseInt(matched.count || 0, 10) : 0;

      const percent = sum > 0 ? Math.round((count / sum) * 100) : 0;
      const displayPercent = count === 0 ? minVisiblePercent : percent;

      // ✅ 중앙 텍스트 2줄(rich) + 컬러 적용
      opt.series[0].detail.formatter = () =>
        `{label|${item.title}}\n{value|${count}}`;
      opt.series[0].detail.rich.label.color = color;
      opt.series[0].detail.rich.value.color = color;

      opt.series[0].name = item.code;
      opt.series[0].itemStyle = { color, borderColor: "#000", borderWidth: 1 };

      opt.series[0].data = [{ value: displayPercent }];

      next.push(opt);
    });

    setOptions(next);
  }, [EquipmentFaultStatusList, statusDatas]);


  function init() {
    const next = [];
    EquipmentFaultStatusList.forEach((item) => {
      if (item.code?.startsWith("O4_C")) return;

      const opt = makeBaseOption();
      if (platformServer === 'NANTONG')
        opt.series[0].axisLine.lineStyle.width = 7

      const color =
        equipmentFaultStatusColors.find((d) => d.code === item.code)?.color ||
        "#4caf50";

      const count = 0;
      const displayPercent = 1;

      // ✅ 중앙 텍스트 2줄(rich) + 컬러 적용
      opt.series[0].detail.formatter = () =>
        `{label|${item.title}}\n{value|${count}}`;
      opt.series[0].detail.rich.label.color = color;
      opt.series[0].detail.rich.value.color = color;

      opt.series[0].name = item.code;
      opt.series[0].itemStyle = { color, borderColor: "#000", borderWidth: 1 };

      opt.series[0].data = [{ value: displayPercent }];

      next.push(opt);
    });

    setOptions(next)
  }

  useEffect(() => {
    if (!options || options.length === 0) return;

    const raf = requestAnimationFrame(() => {
      chartRefs.current.forEach((c) => c?.resize?.());
    });

    const onResize = () => chartRefs.current.forEach((c) => c?.resize?.());
    window.addEventListener("resize", onResize);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
    };
  }, [options]);
  // if (!options || options.length === 0) return null;

  const addString = "";

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap",
      }}
    >
      {options.map((opt, i) => (
        <div
          key={opt.series[0].name || i}
          style={{
            flex: "1 1 0",
            minWidth: 0,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Link
            to={"/equipment?searchStatus=" + opt.series[0].name + addString}
            style={{ display: "block" }}
          >
            {/* ✅ 원 더 크게: clamp 최소/최대 올림 */}
            <div
              style={{
                width: `${platformServer === 'NANTONG' ? 'clamp(90px, 24vw, 80px)' : 'clamp(170px, 24vw, 260px)'}`
                , height: `${(platformServer === 'NANTONG' || platformServer === 'YIHAI') ? '' : 'clamp(100px, 20vw, 145px)'}`
                , marginTop: `${(platformServer === 'NANTONG' || platformServer === 'YIHAI') ? '' : '20px'}`
              }}
            >
              <ECharts
                option={opt}
                opts={{ renderer: "svg" }}
                style={{ width: "100%", height: "100%", display: "block" }}
                notMerge={true}
                lazyUpdate={true}
                onChartReady={(chart) => {
                  chartRefs.current[i] = chart;
                  chart.resize();
                }}
              />
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default StatusChart;
